/** pt-BR formatting helpers. */

const dateTime = new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
const dateOnly = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'short' });
const number = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 });
const relative = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto' });

export const formatDateTime = (iso: string | null | undefined) =>
  iso ? dateTime.format(new Date(iso)) : '—';

export const formatDay = (iso: string | null | undefined) =>
  iso ? dateOnly.format(new Date(iso)).replace('.', '') : '—';

/** "15/09": day and month, for chart axes. */
export const formatDayMonth = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }) : '—';

export const formatNumber = (value: number | null | undefined) =>
  value === null || value === undefined ? '—' : number.format(value);

export const formatPercent = (value: number | null | undefined, digits = 0) =>
  value === null || value === undefined
    ? '—'
    : `${value.toLocaleString('pt-BR', { maximumFractionDigits: digits })}%`;

/** "há 3 dias", "em 2 horas"... */
export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return '—';
  const diff = new Date(iso).getTime() - Date.now();
  const abs = Math.abs(diff);
  const units: [Intl.RelativeTimeFormatUnit, number][] = [
    ['day', 86_400_000],
    ['hour', 3_600_000],
    ['minute', 60_000],
  ];
  for (const [unit, ms] of units) {
    if (abs >= ms || unit === 'minute') return relative.format(Math.round(diff / ms), unit);
  }
  return '—';
}

/** ISO (UTC) → value for <input type="datetime-local"> in the user's timezone. */
export function toLocalInput(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = new Date(iso);
  const offset = date.getTimezoneOffset() * 60_000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
}

/** <input type="datetime-local"> value → ISO (UTC), or null when empty. */
export function fromLocalInput(value: string): string | null {
  return value ? new Date(value).toISOString() : null;
}

export function formatDuration(minutes: number | null | undefined): string {
  if (minutes === null || minutes === undefined) return '—';
  if (minutes < 60) return `${Math.round(minutes)} min`;
  const h = Math.floor(minutes / 60);
  const m = Math.round(minutes % 60);
  return m ? `${h}h${String(m).padStart(2, '0')}` : `${h}h`;
}

export function pluralize(count: number, singular: string, plural: string) {
  return `${count.toLocaleString('pt-BR')} ${count === 1 ? singular : plural}`;
}
